var $ = jQuery;

var playMainVideo = require("./playMainVideo.js");

$(document).ready(function(){
	
	require("./CommentsAccordion.js")();
	require("./EventTracking.js")();
	require("./Scrollbars.js")();
	require("./ShowTags.js")();
	require("./VideoCommentForm.js")();
	require("./BesideVideo.js")();

	$(document).on("click",".video-poster-play-button, .video-poster-image",function(e){
		e.preventDefault();
		playMainVideo();
	});
	
});